module.exports = __webpack_public_path__ + "19eecdf8d27eb78f8f69f3fda321ef81.pdf";